import React from "react";
import "./CustomButton.css";

interface ButtonProps {
  label: string;
  disabled?: boolean;
  onClick: () => void;
}

const CustomButton: React.FC<ButtonProps> = ({ label, disabled, onClick }) => {
  return (
    <button onClick={onClick} disabled={disabled ?? false} className="custom-button-container">
      {label}
    </button>
  );
};

export default CustomButton;